import * as React from "react"

const MenuIcon = (props) => (
    <svg {...props} viewBox="0 0 26 16" height={props.height} width={props.width} xmlns="http://www.w3.org/2000/svg">
    <title>{"Menu"}</title>
    <g
    stroke={props.stroke}
    strokeWidth={1.2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    >
    <path d="M1 .615h24.237M1 8h24.237M1 15.385h24.237" />
    </g>
    </svg>
)

export default MenuIcon
